module.exports = __webpack_public_path__ + "static/media/29BDOS1.816a3cdb.jpg";